import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { AttrIndexService } from 'app/services/attr-index.service';
import { CenterlineSide } from 'app/services/resolution-center.service';

@Component({
  selector: 'app-line-with-measure',
  templateUrl: './line-with-measure.component.html',
  styleUrls: ['./line-with-measure.component.css']
})
export class LineWithMeasureComponent implements OnInit {

	fromLeftColName: string;
	toLeftColName: string;
	fromRightColName: string;
	toRightColName: string;

	showJointChangeLeft = true;
	showJointChangeRight = true;

	@Input() rec;
	@Input() splitIdx: number;

	@Output() jointChange: EventEmitter<any> = new EventEmitter();
	constructor(
		private attrIndexService: AttrIndexService
	) { }

	onEdit() {}

	clickJointChange(side: CenterlineSide) {
		this.jointChange.emit({
			side: side,
			idx: this.splitIdx
		})
	}
	ngOnInit() {
		this.fromLeftColName = this.attrIndexService.fromAddrLeftColName;
		this.toLeftColName = this.attrIndexService.toAddrLeftColName;
		this.fromRightColName = this.attrIndexService.fromAddrRightColName;
		this.toRightColName = this.attrIndexService.toAddrRightColName;
	}

}
